export default __webpack_public_path__ + "static/media/cross.0dcd79c0.svg";